import { activityStatus, contentTags } from "Constants/constants";
import studentRecordService from "Services/StudentRecordService";
import {uuidToHEX} from "Services/util";
import studentInformationService from "Services/StudentInformationService";
import {getUserData, setUserData} from "Services/API";
import { recommendationModes } from "../constants/constants";
import { getNextErssActivity } from "./erssService";

const earlyReaderSequenceStart = "cb95adf1-b253-46ed-a3be-8ef2f344a660";
const spanishEarlyReaderSequenceStart = "2c4ae420-f668-11ec-b9fa-1f71bfc996aa";

export function getEarlyReaderMode(story = {}) {
  const tags = (story && story.tags && story.tags.length) ? story.tags : [];
  return {
    readWithMe: tags.includes(contentTags.EARLY_READER_READ_WITH_ME),
    wordList: tags.includes(contentTags.EARLY_READER_WORD_LIST),
    repetitiveText: tags.includes(contentTags.EARLY_READER_REPETITIVE_TEXT),
    changeOnePart: tags.includes(contentTags.EARLY_READER_CHANGE_ONE_PART),
    upAndDown: tags.includes(contentTags.EARLY_READER_UP_AND_DOWN),
    letterFlies: tags.includes(contentTags.EARLY_READER_LETTER_FLIES),
    elkoninBoxes: tags.includes(contentTags.EARLY_READER_ELKONIN_BOXES) || tags.includes(contentTags.EARLY_READER_ELKONIN),
  }
}

export function endOfEarlyReaderSequence(activity){
  if(!activity){
    return false;
  }
  const { status, story } = activity;
  const tags = (story.tags && story.tags.length) ? story.tags : [];
  return status === activityStatus.SCORED && tags.includes(contentTags.EARLY_READER_SEQUENCE_END)
}

export function clearEarlyReaderSequenceStart(locale){
  let earlyReaderSequenceStories = getUserData().sequenceStartStories;
  earlyReaderSequenceStories = earlyReaderSequenceStories.filter(element => element.locale !== locale);
  setUserData("earlyReaderSequenceStories",earlyReaderSequenceStories);
  if(earlyReaderSequenceStories.length === 0){
    setUserData("earlyReaderSequenceStart",false)
    setUserData("startingEarlyReaderSequence",false)
  }

}

export async function getNextEarlyReaderStory(userId, isEarlyReader, isSpanishEarlyReader){
  let nextActivities = await getNextErssActivity(userId,isEarlyReader,isSpanishEarlyReader);
  //We're doing this here to immunize the service from the tech debt we have due to the different representations of locale in the client
  const sequenceStartStories = JSON.parse(JSON.stringify(nextActivities).replace('EN_US','en-us').replace('ES_MX','es-mx'));
  return sequenceStartStories.nextStories;
}

export function isEarlyReaderInSequence(sequence,locale){
  const storyInSequence = sequence.find(story=>story.locale === locale);
  return (storyInSequence && storyInSequence.storyId) ? true : false;
}

export async function hasEarlyReaderSequenceInProgress(userId,locale='en-us'){
  const tutorActivities = await studentRecordService.getRecommendedStories(uuidToHEX(userId),0,"tutor",1,"",recommendationModes.SEQUENCE_LOCKED,locale);
  if(!tutorActivities.length){
    return false;
  }
  return tutorActivities.some(story => isEarlyReaderStory(story));
}

export function shouldFilterStoryFromReport(activity, scale) {
  const { storyTags } = activity;

  // return false if storyTags is null
  if (!storyTags) return false

  //Allow Word List and Repetitive Text if we are using ARM scale
  if(scale && scale == "ARM") {
    let returnValue = isEarlyReader(activity) && !storyTags.includes(contentTags.EARLY_READER_WORD_LIST) && !storyTags.includes(contentTags.EARLY_READER_REPETITIVE_TEXT) && activity.displayStatus != 'prereader';
    return returnValue;

  } else {
    let returnValue = isEarlyReader(activity);
    return returnValue;
  }
}

export function isEarlyReader(activity) {
  const { storyTags } = activity;

  // return false if storyTags is null
  if (!storyTags) return false

  return (storyTags.includes(contentTags.EARLY_READER_READ_WITH_ME) || storyTags.includes(contentTags.EARLY_READER_WORD_LIST) || storyTags.includes(contentTags.EARLY_READER_REPETITIVE_TEXT)  || storyTags.includes(contentTags.EARLY_READER_LETTER_FLIES) || storyTags.includes(contentTags.EARLY_READER_UP_AND_DOWN)  || storyTags.includes(contentTags.EARLY_READER_ELKONIN_BOXES) || storyTags.includes(contentTags.EARLY_READER_ELKONIN) || storyTags.includes(contentTags.EARLY_READER_CHANGE_ONE_PART) || activity.displayStatus === 'prereader');
}

export function isEarlyReaderStory(story) {
  if(!story) return false;

  const storyTags = story && story.tags;
  if (!storyTags) return false

  return (storyTags.includes(contentTags.EARLY_READER_READ_WITH_ME) || storyTags.includes(contentTags.EARLY_READER_WORD_LIST) || storyTags.includes(contentTags.EARLY_READER_REPETITIVE_TEXT)  || storyTags.includes(contentTags.EARLY_READER_LETTER_FLIES) || storyTags.includes(contentTags.EARLY_READER_UP_AND_DOWN)  || storyTags.includes(contentTags.EARLY_READER_ELKONIN_BOXES)  || storyTags.includes(contentTags.EARLY_READER_ELKONIN) || storyTags.includes(contentTags.EARLY_READER_CHANGE_ONE_PART));
}

export function isScorableEarlyReaderStory(story){
  if(!story) return false;

  const storyTags = story && story.tags;
  if (!storyTags) return false

  return (storyTags.includes(contentTags.EARLY_READER_WORD_LIST) || storyTags.includes(contentTags.EARLY_READER_REPETITIVE_TEXT)  || storyTags.includes(contentTags.EARLY_READER_LETTER_FLIES) || storyTags.includes(contentTags.EARLY_READER_UP_AND_DOWN)  || storyTags.includes(contentTags.EARLY_READER_ELKONIN)  || storyTags.includes(contentTags.EARLY_READER_CHANGE_ONE_PART));
}

export function isEarlyReaderActivity(activity){
  if(!activity){
    return false;
  }
  const tags = (activity && activity.story && activity.story.tags && activity.story.tags.length) ? activity.story.tags : [];
  return(tags.includes(contentTags.EARLY_READER_READ_WITH_ME) || tags.includes(contentTags.EARLY_READER_WORD_LIST) || tags.includes(contentTags.EARLY_READER_REPETITIVE_TEXT));
}

export function isEarlyReaderMode(state){
  return (state && (state.readWithMe || state.wordList || state.repetitiveText || state.changeOnePart || state.upAndDown || state.letterFlies || state.elkoninBoxes));
}

export async function flagNewEarlyReader(studentId,locale){
  let newMeta = {esl: getUserData().isESL, early_reader: getUserData().isEarlyReader, spanish_early_reader: getUserData().isSpanishEarlyReader,tutorInSpanish: getUserData().tutorInSpanish};
  if(locale === 'en-us'){
    newMeta.early_reader = true;
    setUserData("isEarlyReader", true);
  }else{
    newMeta.spanish_early_reader = true;
    setUserData("isSpanishEarlyReader", true);
  }
  await studentInformationService.updateStudentMetadata(studentId, newMeta);

  setUserData("startingEarlyReaderSequence", true);
}

export async function clearEarlyReader(studentId,locale='en-us'){
  let newMeta = {esl: getUserData().isESL, early_reader: getUserData().isEarlyReader, spanish_early_reader: getUserData().isSpanishEarlyReader, tutorInSpanish: getUserData().tutorInSpanish};
  if(locale === 'en-us'){
    newMeta.early_reader = false;
    setUserData("isEarlyReader", false);
  }else{
    newMeta.spanish_early_reader = false;
    setUserData("isSpanishEarlyReader", false);
  }
  await studentInformationService.updateStudentMetadata(studentId, newMeta);
  setUserData("startingEarlyReaderSequence", false);
}

export default {
  getEarlyReaderMode,
  endOfEarlyReaderSequence,
  hasEarlyReaderSequenceInProgress,
  isEarlyReaderActivity,
  isEarlyReaderMode,
  flagNewEarlyReader,
  clearEarlyReader,
}
